<script>
import { Pagination } from 'element-ui'
import { h, provide } from 'vue'

export default {
  //防止触发表单校验
  componentName: 'ElFormItem',
  components: {
    [Pagination.name]: Pagination,
  },
  setup(props, { attrs, listeners }) {
    //处理在表单中必填时出现bug
    provide('elFormItem', '')
    provide('elForm', '')

    return () =>
      h(Pagination.name, {
        class: 'pg-pagination',
        props: {
          background: true,
          layout: 'total, prev, pager, next, sizes, jumper',
          ...attrs,
        },
        on: listeners,
      })
  },
}
</script>
<style lang="scss">
@import '../style/pagination.scss';
</style>
